import RingAngled from '../../src/legacy/RingAngled.tsx';
export default RingAngled;
